import { render, staticRenderFns } from "./CriarCampanhas.vue?vue&type=template&id=10ede8a8"
import script from "./CriarCampanhas.vue?vue&type=script&lang=js"
export * from "./CriarCampanhas.vue?vue&type=script&lang=js"
import style0 from "./CriarCampanhas.vue?vue&type=style&index=0&id=10ede8a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports